import React, {
    createContext,
    useContext,
    useState,
    ReactNode,
} from "react";


export type User = {
    id: string;
    name: string;
    email?: string;
    role?: "user" | "admin";
};

type UserContextType = {
    user: User | null;
    setUser: (user: User | null) => void;
    updateUser: (patch: Partial<User>) => void;
    logout: () => void;
};

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider = ({ children }: { children: ReactNode }) => {
    const [user, setUser] = useState<User | null>(null);

    const updateUser = (patch: Partial<User>) => {
        setUser(prev =>
            prev ? { ...prev, ...patch } : prev
        );
    };

    const logout = () => {
        setUser(null);
    };

    return (
        <UserContext.Provider value={{user, setUser, updateUser, logout,}} >
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => {
    const ctx = useContext(UserContext);

    if (!ctx) {
        throw new Error("useUser must be used within UserProvider");
    }

    return ctx;
};
